/* eslint-disable react/no-multi-comp */

import React from 'react'
import { connect } from 'react-redux'
import { createSelector } from 'reselect'
import { values } from 'lodash'
import { Link } from 'react-router'

import {
  Modal, Panel, Form, FormGroup, FormControl, ControlLabel
} from 'react-bootstrap'

import Button from '../components/Button'
import { createDoc, updateDoc } from '../ducks/appDocs'
import CitySelector from '../cities/CitySelector'
import { randstr } from '../../lib/Tools'
import { getActivitiesList } from '../selectors/index'

/**
 * TODO
 * - [ ] Comentar esta mierda
 * - [ ] Mostrar las ciudades por nombre y título, no id
 * - [ ] Botón para eliminar actividades
 */

class AddSuggestionButton extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = { city: "Madrid", adding: false }
  }

  render() {
    const { onSelection } = this.props

    return (
      <div>
        <Button onClick={() => this.setState({ adding: true })}>Añadir sugerencias para otra ciudad</Button>

        {
          this.state.adding && (
            <Modal show onHide={() => this.setState({ adding: false })}>
              <Modal.Header>Añadir sugerencias para la ciudad:</Modal.Header>
              <Modal.Body>
                <CitySelector
                  cityId={this.state.city}
                  onChange={city => this.setState({ city })}
                  countryLabel="País:"
                  cityLabel="Ciudad:"
                />
              </Modal.Body>
              <Modal.Footer>
                <Button onClick={() => this.setState({ adding: false })}>
                  Cancelar
                </Button>
                <Button onClick={() => { onSelection(this.state.city); this.setState({ adding: false }) }}>
                  Seleccionar
                </Button>
              </Modal.Footer>
            </Modal>
          )
        }
      </div>
    )
  }
}

class AddActivityButton extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = { adding: false }
  }

  render() {
    const { onSelection, activitiesList, cityId } = this.props

    const activitiesInCity = activitiesList.filter(a => a.city == cityId)

    return (
      <div>
        <Button onClick={() => this.setState({ adding: true })}>Añadir actividad</Button>

        {
          this.state.adding && (
            <Modal show onHide={() => this.setState({ adding: false })}>
              <Modal.Header>Añadir sugerencias para la ciudad:</Modal.Header>
              <Modal.Body>
                <FormControl
                  componentClass="select"
                  placeholder="select"
                  onChange={evt => {
                    if (evt.target.value != "NULL") {
                      onSelection(evt.target.value);
                      this.setState({ adding: false });
                    }
                  }}
                >
                  <option value="NULL">Elije una actividad</option>
                  {
                    activitiesInCity
                      .map(({_id, name, title}) => <option key={_id} value={_id}>{`${name} // ${title}`}</option>)
                  }
                </FormControl>
              </Modal.Body>
              <Modal.Footer>
                <Button onClick={() => this.setState({ adding: false })}>Cancelar</Button>
              </Modal.Footer>
            </Modal>
          )
        }
      </div>
    )
  }
}

const getActivityLabel = (Activities, id) => {
  const a = Activities[id]
  const ploc = a.preciseLocation
  const loc = ploc && ploc.latitude ? `${ploc.latitude}, ${ploc.longitude}` : null

  if (!a) return id
  else return (
    <span>
      {`${a.name || "No name"} / ${a.title || "No title"}`}
      { loc && ` (${loc})`}
      { !loc && <span style={{color: "red", fontWeight: 500}}> [Missing location!]</span> }
    </span>
  )
}

const iconTypes = [
  "material", "material-community", "zocial", "font-awesome", "octicon", "ionicon",
  "foundation", "evilicon", "simple-line-icon", "feather", "entypo"
]

const Section = ({ section, cityId, onChange, Activities, activitiesList }) => (
  <Panel style={{ backgroundColor: "rgba(159,234,215,0.1)" }}>
    <Panel.Body>
      <Form inline>
        <FormGroup>
          <ControlLabel style={{marginRight: 15}}>Título de la sección (en chino): </ControlLabel>
          <FormControl value={section.title} onChange={evt => onChange({...section, title: evt.target.value})} />
        </FormGroup>
        <br />
        <FormGroup>
          <ControlLabel style={{marginRight: 15}}>Orden: </ControlLabel>
          <FormControl
            type="number"
            value={section.order || 0}
            onChange={evt => onChange({...section, order: parseInt(evt.target.value)})}
          />
        </FormGroup>
        <ControlLabel>Actividades:</ControlLabel>
        <ul>
          {
            (section.activities || []).map(id => (
              <li key={id}>
                <Button glyph="remove" bsSize="sm" onClick={() => onChange({ ...section, activities: section.activities.filter(x => x != id) })} />
                <span style={{ marginLeft: 10, marginRight: 6 }}>{getActivityLabel(Activities, id)}</span>
                (<Link to={`/private/activity/${encodeURIComponent(id)}?`}>Enlace</Link>)
              </li>
            ))
          }
          <li>
            <AddActivityButton
              activitiesList={activitiesList}
              cityId={cityId}
              onSelection={v => onChange({ ...section, activities: [...section.activities, v] })}
            />
          </li>
        </ul>
        <FormGroup>
          <ControlLabel style={{ marginRight: 15 }}>Icono: </ControlLabel>
          <FormControl
            value={section.icon && section.icon.name}
            onChange={evt => onChange({ ...section, icon: { ...section.icon, name: evt.target.value } })}
          />
          <FormControl
            componentClass="select"
            style={{ marginLeft: 5, marginRight: 5 }}
            value={section.icon && section.icon.type}
            onChange={evt => onChange({ ...section, icon: { ...section.icon, type: evt.target.value } })}
          >
            {
              iconTypes.map(type => <option value={type} key={type}>{type}</option>)
            }
          </FormControl>
        </FormGroup>
        <a href="https://oblador.github.io/react-native-vector-icons/">Directorio</a>
      </Form>
    </Panel.Body>
  </Panel>
)

const AppDocsPage = ({ nearBySuggestions, createSuggestion, update, Cities, Activities, activitiesList }) => (
  <div style={{paddingLeft: 40, paddingRight: 40}}>
    <h2>Documentos para apps</h2>

    <AddSuggestionButton
      onSelection={cityId => {
        if (nearBySuggestions.some(doc => doc.cityId == cityId)) alert("Repetidos no! >.<")
        else createSuggestion(cityId)
      }}
    />

    {
      nearBySuggestions
        .map(doc => (
          <Panel
            key={doc._id}
            style={{ backgroundColor: "rgba(159,234,215,0.1)" }}
          >
            <Panel.Heading>Sugerencias para {Cities[doc.cityId].name}</Panel.Heading>
            <Panel.Body>
              {
                doc.data
                  .sort((a, b) => (a.order || 0) - (b.order || 0))
                  .map(section => (
                    <Section
                      key={section.key}
                      section={section}
                      cityId={doc.cityId}
                      Activities={Activities}
                      activitiesList={activitiesList}
                      onChange={section => {
                        update(doc._id, { data: [section, ...(doc.data.filter(x => x.key != section.key))] })
                      }}
                    />
                  ))
              }
              <Button onClick={() => update(doc._id, { data: [...(doc.data || []), { key: randstr(), title: "Untitled", activities: [] }] })}>
                Nueva sección
              </Button>
            </Panel.Body>
          </Panel>
        ))
    }
  </div>
)

const getNearBySuggestions = createSelector(
  [state => state.appdocs],
  appDocs => values(appDocs).filter(doc => doc.docType == "nearBySuggestion")
)

const stateToProps = (state, ownProps) => ({
  nearBySuggestions: getNearBySuggestions(state, ownProps),
  Cities: state.cities,
  activitiesList: getActivitiesList(state, ownProps),
  Activities: state.activities,
})

const dispatchToProps = dispatch => ({
  createSuggestion: cityId => dispatch(createDoc({ cityId, docType: "nearBySuggestion", data: [] })),
  update: (id, changes) => dispatch(updateDoc(id, changes)),
})

export default connect(stateToProps, dispatchToProps)(AppDocsPage)
